import axios from 'axios';
import { bundle } from '../../helpers';
import { handleErrors, headerBuilder, paramBuilder } from '../http';
export var fetchKapps = function fetchKapps() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  // Build URL and fetch the space.
  return axios.get("".concat(bundle.apiLocation(), "/kapps"), {
    params: paramBuilder(options),
    headers: headerBuilder(options)
  }).then(function (response) {
    return {
      kapps: response.data.kapps,
      count: response.data.count,
      nextPageToken: response.data.nextPageToken
    };
  })["catch"](handleErrors);
};
export var fetchKapp = function fetchKapp() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _options$kappSlug = options.kappSlug,
      kappSlug = _options$kappSlug === void 0 ? bundle.kappSlug() : _options$kappSlug; // Build URL and fetch the space.

  return axios.get("".concat(bundle.apiLocation(), "/kapps/").concat(kappSlug), {
    params: paramBuilder(options),
    headers: headerBuilder(options)
  }).then(function (response) {
    return {
      kapp: response.data.kapp
    };
  })["catch"](handleErrors);
};
export var updateKapp = function updateKapp() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _options$kappSlug2 = options.kappSlug,
      kappSlug = _options$kappSlug2 === void 0 ? bundle.kappSlug() : _options$kappSlug2,
      kapp = options.kapp;

  if (!kappSlug) {
    throw new Error('updateKapp failed! The option "kappSlug" is required.');
  }

  if (!kapp) {
    throw new Error('updateKapp failed! The option "kapp" is required.');
  }

  return axios.put("".concat(bundle.apiLocation(), "/kapps/").concat(kappSlug), kapp, {
    params: paramBuilder(options),
    headers: headerBuilder(options)
  }).then(function (response) {
    return {
      kapp: response.data.kapp
    };
  })["catch"](handleErrors);
};
export var createKapp = function createKapp() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var kapp = options.kapp;

  if (!kapp) {
    throw new Error('createKapp failed! The option "kapp" is required.');
  }

  return axios.post("".concat(bundle.apiLocation(), "/kapps"), kapp, {
    params: paramBuilder(options),
    headers: headerBuilder(options)
  }).then(function (response) {
    return {
      kapp: response.data.kapp
    };
  })["catch"](handleErrors);
};
export var deleteKapp = function deleteKapp() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var kappSlug = options.kappSlug;

  if (!kappSlug) {
    throw new Error('deleteKapp failed! The option "kappSlug" is required.');
  }

  return axios["delete"]("".concat(bundle.apiLocation(), "/kapps/").concat(kappSlug), {
    params: paramBuilder(options),
    headers: headerBuilder(options)
  }).then(function (response) {
    return {
      kapp: response.data.kapp
    };
  })["catch"](handleErrors);
};